<template>
    <div class="container" :class="`${small ? 'small' : ''} ${slim ? 'slim' : ''} ${percentage_outside ? 'external-percent' : ''}`">
        <div class="progress-bar">
            <div class="progress-bar-fill" :style="{ width: `${percentage}%` }"></div>
            <div class="progress-bar-label" v-if="!percentage_outside">{{ percentage }}{{ label }}{{ text }}</div>
            <div class="progress-bar-label"></div>
        </div>
        <div class="progress-bar-label" :class="percentage_outside ? 'percentage_outside' : ''" v-if="percentage_outside">{{ percentage }}{{ label }}{{ text }}</div>

    </div>
</template>




<script setup>
    import { onMounted, ref, computed, watch } from "vue";

    const props = defineProps({
        current: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        },
        label: {
            type: String,
            default: '%'
        },
        text: {
            type: String,
            default: ''
        },
        small: {
            type: Boolean,
            default: false
        },
        slim: {
            type: Boolean,
            default: false
        },
        percentage_outside: {
            type: Boolean,
            default: false
        }
    })
    const percentage = computed(() => {
        if (props.total === 0) return 0;
        return Math.round((props.current / props.total) * 100);
    });


</script>

<style lang="scss" scoped>

    .progress-bar {
        width: 100%;
        height: 20px;
        background-color: #e0e0e0;
        border-radius: 5px;
        padding: 2px;
        overflow: hidden;
        position: relative;
    }
    
 
    .progress-bar-fill {
        height: 100%;
        box-sizing: border-box;
        border-radius: 5px;
        background-color: rgb(44 164 104);
        transition: width 0.3s ease-in-out;
    }

    .progress-bar-label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 13px;
        // color: black;
        font-weight: bold;
        color: white;
        mix-blend-mode: difference;
        &.percentage_outside {
            position: unset;
            transform: unset;
            font-weight: normal;
        }
    }
    .small {
        .progress-bar {
            padding: 1px;
            height: 16px;
        }
    }
    * {
        box-sizing: border-box;
    }
    .slim {
        .progress-bar {
            height: 10px;
            padding: 0px;
        }
    }
    .external-percent {
        display: flex;
        gap: 10px;
        align-items: center;
    }
</style>